import React, { useState } from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { PageTitle, Input } from '../root/components/common'
import { getCustomersBillingDataQuery } from './api'
import { enqueueSnackbar } from '../root/actions'
import { useQuery } from 'react-query'
import Billing from '../billing'

/* eslint-disable */
export default function Monetisation() {
    const dispatch = useDispatch()
    const classes = useStyles()
    const { theme, locale } = useSelector(state => state.main)
    const [selectedCustomerBilling, setSelectedCustomerBilling] = useState(null)
    const [searchStr, setSearchStr] = useState('')

    const { data: customersBillingData, isLoading } = useQuery(
        ['getCustomersBillingData', searchStr],
        () => getCustomersBillingDataQuery(searchStr),
        {
            refetchOnWindowFocus: false,
            refetchInterval: false,
            onError: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.commonLoadingError,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            }
        }
    )

    return (
        <div className={classNames(classes.wrapper)}>
            <PageTitle
                title={locale.billing.monetisation}
                className={classes.pageTitle}
            ></PageTitle>
            <div className={classes.content}>
                <div
                    style={{
                        width: 240,
                        paddingRight: 20,
                        overflowY: 'auto'
                    }}
                >
                    <div
                        style={{
                            paddingBottom: 20,
                            paddingTop: 10
                        }}
                    >
                        <Input
                            autoFocus
                            label={locale.common.search}
                            type="text"
                            setValue={setSearchStr}
                            debounce={600}
                            size="small"
                            disabled={isLoading}
                        />
                    </div>
                    {isLoading ? (
                        <div
                            style={{
                                paddingBottom: 20
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <div style={{ marginRight: 6 }}>
                                    {locale.common.loading}...
                                </div>
                                <div>
                                    <CircularProgress
                                        size={16}
                                        color={theme.primary}
                                    />
                                </div>
                            </div>
                            <br />
                            {locale.billing.itCanUpToAMinute}
                        </div>
                    ) : null}
                    {!isLoading && customersBillingData ? (
                        <>
                            <div
                                style={{
                                    paddingBottom: 20
                                }}
                            >
                                {locale.billing.currentMonth}
                            </div>
                            {customersBillingData.customers_billing_data.map(
                                cBItem => {
                                    return (
                                        <div
                                            key={cBItem.customer_id}
                                            className={classNames(
                                                classes.hoverOpacity
                                            )}
                                            onClick={() =>
                                                setSelectedCustomerBilling(
                                                    cBItem
                                                )
                                            }
                                            style={{
                                                display: 'flex',
                                                padding: 20,
                                                borderRadius:
                                                    theme.borderRadius,
                                                backgroundColor:
                                                    cBItem.customer_id ===
                                                    selectedCustomerBilling?.customer_id
                                                        ? theme.primary
                                                        : theme.tertiary,
                                                cursor: 'pointer',
                                                marginBottom: 10,
                                                boxShadow:
                                                    '6px 6px 9px -3px rgba(0,0,0,0.15)',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                position: 'relative',
                                                color:
                                                    cBItem.customer_id ===
                                                    selectedCustomerBilling?.customer_id
                                                        ? theme.textPrimaryReverted
                                                        : theme.textPrimary
                                            }}
                                        >
                                            <div
                                                style={{
                                                    wordBreak: 'break-all'
                                                }}
                                            >
                                                {cBItem.customer_name}
                                            </div>
                                            <div
                                                style={{
                                                    fontWeight: 'bold',
                                                    fontSize: 18,
                                                    textAlign: 'right'
                                                }}
                                            >
                                                &nbsp;
                                                {cBItem.current_month_total
                                                    ?.toFixed(2)
                                                    .replace(/\.|\,/g, ',')}
                                                €
                                            </div>
                                        </div>
                                    )
                                }
                            )}
                        </>
                    ) : null}
                </div>
                {selectedCustomerBilling ? (
                    <Billing
                        embedded
                        preselectedBillingData={
                            selectedCustomerBilling.billing_data
                        }
                    />
                ) : null}
            </div>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        justifyContent: 'space-between',
        height: 56
    },
    content: {
        height: 'calc(100% - 56px)',
        display: 'flex'
    },
    hoverOpacity: {
        '&:hover': {
            opacity: 0.75
        }
    },
    cursorPointer: {
        cursor: 'pointer'
    }
}))

/* eslint-enable */
